function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import get from 'lodash/get';
import some from 'lodash/some';
import { mapState, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
  components: {
    Multiselect: Multiselect
  },
  computed: _objectSpread({}, mapState({
    visible: function visible(s) {
      return s.api.resultDisplay === 'matching_expressions';
    },
    executionState: function executionState(s) {
      return s.api.executionState;
    },
    result: function result(s) {
      return s.api.result;
    },
    query: function query(s) {
      return s.api.query;
    },
    currentOffset: function currentOffset(s) {
      return s.pagination.currentOffset;
    },
    frequencyValues: function frequencyValues(s) {
      return s.frequency_groups.frequencyValuesDefault;
    },
    frequencyValuesSelected: function frequencyValuesSelected(s) {
      return s.frequency_groups.frequencyValues;
    },
    frequencyGroupSelected: function frequencyGroupSelected(s) {
      return s.frequency_groups.frequencyGroups;
    }
  }), {}, mapGetters('pagination', ['emptyResult']), {
    showGroupHeader: function showGroupHeader() {
      return some(this.frequencyGroupSelected, function (v, _k) {
        return v.length !== 0;
      });
    },
    show: {
      get: function get() {
        return this.frequencyValuesSelected;
      },
      set: function set(values) {
        this.$store.commit('frequency_groups/setFrequencyValues', values);
      }
    }
  }),
  methods: {
    i18nShowOption: function i18nShowOption(option) {
      return this.$tOr('result.matching_expressions.show_options', option);
    },
    i18nGroupValue: function i18nGroupValue(group, value) {
      return this.$tOr('result.matching_expressions.groups', "".concat(group, ".values.").concat(value), value);
    },
    fullReference: function fullReference(group, value, key) {
      return get(this.result.full_reference, [group, value, key], 0);
    },
    onRemoveOption: function onRemoveOption(option) {
      if (this.show.length === 1 && this.show[0] === option) {
        this.$refs.showOptions.activate();
      }
    },
    onCloseOptions: function onCloseOptions() {
      if (this.show.length === 0) {
        this.show = ['frequency'];
      }
    }
  }
};